import { HomeMainModule } from './home-main/home-main.module';
import { GetStartedModule } from './get-started/get-started.module';
import { QuestionarieSignupModule } from './questionarie-signup/questionarie-signup.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FAQModule } from './faq/faq.module';
import { ResidentialService } from './questionarie-signup/questionnaire-residential/residential.service';
import { FormsModule } from '@angular/forms';
import { ChartModule } from 'angular-highcharts';
import { LoginModule } from './login/login.module';
import { RecommendationService } from './questionarie-signup/questionnaire-residential/recommendation/recommendation.service';
import { GivebackModule } from './giveback/giveback.module';
import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ShareButtonModule } from 'ngx-sharebuttons';
import { UserSettingsModule } from './user-settings/user-settings.module';
import { CommercialModule } from './commercial/commercial.module';
import { HgBlogModule } from './hg-blog/hg-blog.module';
import { AdminUtilityModule } from './admin-utility/admin-utility.module';
import {
  CloudinaryModule,
  CloudinaryConfiguration,
} from '@cloudinary/angular-5.x';
import { Cloudinary } from 'cloudinary-core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { MaterialModule } from './material-module';

@NgModule({
  declarations: [AppComponent, SnackbarComponent],
  imports: [
    BrowserModule,
    MaterialModule,
    FormsModule,
    HomeMainModule,
    GetStartedModule,
    QuestionarieSignupModule,
    FAQModule,
    ChartModule,
    LoginModule,
    AdminUtilityModule,
    UserSettingsModule,
    GivebackModule,
    GooglePlaceModule,
    CommercialModule,
    HgBlogModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDGLXj7CWMeCf-OcQFz3lUTglkuDDYg_6c',
      libraries: ['places'],
    }),
    CloudinaryModule.forRoot({ Cloudinary }, {
      cloud_name: 'honest-gorilla',
      apiKey: '296385853685453',
    } as CloudinaryConfiguration),
    ShareButtonModule.forRoot(),
    CommercialModule,
    ModalModule.forRoot(),
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    ResidentialService,
    RecommendationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
